(function () {
  if (window.__rebuyMainProductSyncInstalled) return;
  window.__rebuyMainProductSyncInstalled = true;

  const clampQty = (n) => {
    if (!Number.isFinite(n) || n < 1) return 1;
    return Math.min(Math.floor(n), 999);
  };

  const normalizeVariantId = (val) => {
    if (val == null || val === "") return null;
    const s = String(val).trim();
    if (/^\d+$/.test(s)) return s;
    const m = s.match(/ProductVariant\/(\d+)/);
    return m ? m[1] : null;
  };

  const quantityFromOptionValue = (raw) => {
    if (raw == null || raw === "") return null;
    const s = String(raw).trim();
    if (!/\d/.test(s)) return null;
    if (/^gid:\/\//i.test(s)) return null;
    if (/^\d+$/.test(s) && s.length >= 10) return null;
    const m = s.match(/(\d+)/);
    if (!m) return null;
    const n = parseInt(m[1], 10);
    if (!Number.isFinite(n) || n < 1) return null;
    return clampQty(n);
  };

  const lineQuantityFromOption = (select, option) => {
    if (!option) return 1;
    if (select.dataset.rebuySyncLineQty === "false") return 1;

    const fromValue = quantityFromOptionValue(option.value);
    if (fromValue != null) return fromValue;

    let base = 1;
    const attr =
      option.getAttribute("data-rebuy-line-qty") ||
      option.getAttribute("data-rebuy-quantity");
    if (attr) {
      base = clampQty(parseInt(attr, 10));
    } else if (select.dataset.rebuyQtyFromIndex === "true") {
      base = clampQty(option.index + 1);
    } else {
      const rawText = option.textContent || "";
      const beforeMoney = rawText.split(/\$|\u00a3|\u20ac|\bCAD\b|\bUSD\b|\bEUR\b|\bGBP\b/i)[0];
      const head = (beforeMoney || rawText).trim();
      const nums = [...head.matchAll(/\d+/g)].map((m) => parseInt(m[0], 10));
      const plausible = nums.filter((n) => n >= 1 && n <= 96);
      if (plausible.length) {
        base = clampQty(Math.min(...plausible));
      } else {
        const any = rawText.match(/(\d+)/);
        base = any ? clampQty(parseInt(any[1], 10)) : 1;
      }
    }

    return base;
  };

  const getRebuyWidget = (el) => el?.closest("[data-rebuy-id]") ?? null;

  const getSubscriptionFrequencySelect = (widget) => {
    if (!widget) return null;
    return (
      widget.querySelector("select.subscription-frequency.rebuy-select") ||
      widget.querySelector("select.rebuy-select.subscription-frequency")
    );
  };

  const getVariantSelectFromBlock = (block) => {
    if (!block) return null;
    const lists = block.querySelectorAll("select");
    for (const s of lists) {
      if (s.classList.contains("subscription-frequency")) continue;
      if (normalizeVariantId(s.value)) return s;
    }
    return null;
  };

  const getQtyForInteraction = (widget, block) => {
    const bundleSel = block?.querySelector(
      "select.rebuy-select:not(.subscription-frequency)"
    );
    if (bundleSel) {
      return lineQuantityFromOption(
        bundleSel,
        bundleSel.options[bundleSel.selectedIndex]
      );
    }
    const sub = getSubscriptionFrequencySelect(widget);
    if (sub) {
      return lineQuantityFromOption(sub, sub.options[sub.selectedIndex]);
    }
    return null;
  };

  const applyQtyInputsInBlock = (block, qty) => {
    if (!block) return;
    block
      .querySelectorAll(
        'input[name="quantity"], input[type="number"].rebuy-quantity, .rebuy-quantity input[type="number"]'
      )
      .forEach((inp) => {
        inp.value = String(qty);
        inp.dispatchEvent(new Event("input", { bubbles: true }));
        inp.dispatchEvent(new Event("change", { bubbles: true }));
      });
  };

  let pendingContext = null;
  let rebuyQtyFixing = false;

  function checkboxAllowsBlock(block) {
    if (!block) return true;
    const cb = block.querySelector(
      "input.checkbox-input.rebuy-checkbox, input.rebuy-checkbox.checkbox-input, input.rebuy-checkbox"
    );
    if (!cb) return true;
    return !!cb.checked;
  }

  function resolveDesiredQtyFromDom(lineItem) {
    const lineVid = normalizeVariantId(
      lineItem?.variant_id ?? lineItem?.variantId ?? lineItem?.variant?.id
    );
    let bestBlock = null;
    for (const block of document.querySelectorAll(".rebuy-product-block")) {
      const varSel = getVariantSelectFromBlock(block);
      const selVid = varSel ? normalizeVariantId(varSel.value) : null;
      if (lineVid && selVid && lineVid === selVid) {
        bestBlock = block;
        break;
      }
    }
    if (!bestBlock) {
      const bundleSelects = document.querySelectorAll(
        ".rebuy-product-block select.rebuy-select:not(.subscription-frequency)"
      );
      if (bundleSelects.length === 1) {
        bestBlock = bundleSelects[0].closest(".rebuy-product-block");
      }
    }
    if (!bestBlock) return null;
    if (!checkboxAllowsBlock(bestBlock)) return null;
    const widget = getRebuyWidget(bestBlock);
    if (!widget) return null;
    const q = getQtyForInteraction(widget, bestBlock);
    return q == null || !Number.isFinite(q) ? null : q;
  }

  function resolveDesiredQty(lineItem) {
    const fromDom = resolveDesiredQtyFromDom(lineItem);
    if (fromDom != null && fromDom >= 1) return fromDom;
    const pc = pendingContext;
    const lineVid = normalizeVariantId(
      lineItem?.variant_id ?? lineItem?.variantId ?? lineItem?.variant?.id
    );
    if (
      pc &&
      performance.now() < pc.until &&
      pc.qty >= 1 &&
      (pc.variantId == null || (lineVid && String(pc.variantId) === lineVid))
    ) {
      return pc.qty;
    }
    return null;
  }

  function getCartChangeUrl() {
    if (
      typeof KROWN !== "undefined" &&
      KROWN.settings &&
      KROWN.settings.routes &&
      KROWN.settings.routes.cart_change_url
    ) {
      return KROWN.settings.routes.cart_change_url;
    }
    return "/cart/change";
  }

  function correctLineQtyAfterRebuyAdd(lineItem) {
    if (!lineItem || typeof lineItem !== "object") return;
    if (rebuyQtyFixing) return;
    const desired = resolveDesiredQty(lineItem);
    if (desired == null || desired < 1) return;
    const current = parseInt(String(lineItem.quantity ?? lineItem.qty ?? 1), 10);
    if (!Number.isFinite(current) || current < 1) return;
    if (desired === current) return;

    rebuyQtyFixing = true;
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      rebuyQtyFixing = false;
    };

    const tryRebuyApi = () => {
      const Cart = window.Rebuy && window.Rebuy.Cart;
      if (!Cart) return false;
      if (typeof Cart.setItemQuantity === "function") {
        Cart.setItemQuantity(lineItem, desired, done);
        setTimeout(done, 4000);
        return true;
      }
      if (typeof Cart.changeItem === "function" && lineItem.key) {
        Cart.changeItem(
          { id: lineItem.key, quantity: desired },
          { success: done, error: done }
        );
        setTimeout(done, 4000);
        return true;
      }
      return false;
    };

    if (tryRebuyApi()) {
      return;
    }

    const key = lineItem.key;
    if (!key) {
      done();
      return;
    }

    fetch(getCartChangeUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: desired }),
    })
      .finally(done)
      .then(() => {
        try {
          if (typeof window.refreshCart === "function") {
            window.refreshCart(false, false);
          }
        } catch (e) {
          /* ignore */
        }
      });
  }

  document.addEventListener(
    "rebuy:cart.add",
    function (e) {
      const d = e && e.detail;
      const line =
        (d && (d.item || d.line_item || d.lineItem || d.line)) || null;
      if (!line) return;
      requestAnimationFrame(function () {
        setTimeout(function () {
          correctLineQtyAfterRebuyAdd(line);
        }, 100);
      });
    },
    false
  );

  const tryPatchInit = (init, ctx) => {
    if (!init || !ctx) return init;
    try {
      if (typeof init.body === "string") {
        const parsed = JSON.parse(init.body);
        if (Array.isArray(parsed) && parsed.length) {
          if (parsed.length === 1) {
            const row = parsed[0];
            if (row && typeof row === "object") {
              const id = normalizeVariantId(row.id ?? row.variant_id);
              if (!ctx.variantId || (id && id === String(ctx.variantId))) {
                row.quantity = ctx.qty;
                return { ...init, body: JSON.stringify(parsed) };
              }
            }
          } else if (ctx.variantId) {
            const vid = String(ctx.variantId);
            const next = parsed.map((item) => {
              if (!item || typeof item !== "object") return item;
              const id = normalizeVariantId(item.id ?? item.variant_id);
              if (id && id === vid) return { ...item, quantity: ctx.qty };
              return item;
            });
            if (next.some((it, i) => it.quantity !== parsed[i].quantity)) {
              return { ...init, body: JSON.stringify(next) };
            }
          }
        } else if (parsed.items && Array.isArray(parsed.items) && parsed.items.length) {
          if (ctx.variantId) {
            const vid = String(ctx.variantId);
            const next = parsed.items.map((item) => {
              const id = normalizeVariantId(item.id ?? item.variant_id);
              if (id && id === vid) {
                return { ...item, quantity: ctx.qty };
              }
              return item;
            });
            if (next.some((it, i) => it.quantity !== parsed.items[i].quantity)) {
              return { ...init, body: JSON.stringify({ ...parsed, items: next }) };
            }
          } else if (parsed.items.length === 1) {
            parsed.items[0] = { ...parsed.items[0], quantity: ctx.qty };
            return { ...init, body: JSON.stringify(parsed) };
          }
        } else if (parsed.id != null) {
          const id = normalizeVariantId(parsed.id);
          if (!ctx.variantId || id === String(ctx.variantId)) {
            parsed.quantity = ctx.qty;
            return { ...init, body: JSON.stringify(parsed) };
          }
        }
      } else if (init.body instanceof FormData) {
        const id = init.body.get("id");
        if (id != null) {
          const nid = normalizeVariantId(id);
          if (!ctx.variantId || nid === String(ctx.variantId)) {
            init.body.set("quantity", String(ctx.qty));
            return init;
          }
        }
        const item0Id =
          init.body.get("items[0][id]") ?? init.body.get("items[0][variant_id]");
        if (item0Id != null) {
          const nid = normalizeVariantId(item0Id);
          const hasRowQty =
            typeof init.body.has === "function"
              ? init.body.has("items[0][quantity]")
              : init.body.get("items[0][quantity]") != null;
          if (hasRowQty && (!ctx.variantId || nid === String(ctx.variantId))) {
            init.body.set("items[0][quantity]", String(ctx.qty));
            return init;
          }
        }
      }
    } catch {
      /* ignore */
    }
    return init;
  };

  const getFetchUrl = (input) => {
    if (typeof input === "string") return input;
    if (input instanceof Request) return String(input.url || "");
    const u = input?.url;
    return u == null ? "" : String(u);
  };

  document.addEventListener(
    "change",
    (e) => {
      const t = e.target;
      if (!t || t.tagName !== "SELECT") return;
      if (
        !t.matches(
          "select.rebuy-select, select.subscription-frequency.rebuy-select, select.rebuy-select.subscription-frequency"
        )
      ) {
        return;
      }
      const widget = getRebuyWidget(t);
      const block = t.closest(".rebuy-product-block");
      if (!block || !widget) return;
      const qty = getQtyForInteraction(widget, block);
      if (qty != null) applyQtyInputsInBlock(block, qty);
    },
    true
  );

  function registerPendingRebuyCartContext(e) {
    const btn = e.target.closest(".rebuy-button");
    if (!btn) return;
    const widget = getRebuyWidget(btn);
    const block = btn.closest(".rebuy-product-block");
    if (!widget || !block) return;

    const hasSub = !!getSubscriptionFrequencySelect(widget);
    const hasPlainRebuySelect = !!block.querySelector(
      "select.rebuy-select:not(.subscription-frequency)"
    );

    if (!hasSub && !hasPlainRebuySelect) return;

    const qty = getQtyForInteraction(widget, block);
    if (qty == null) return;

    applyQtyInputsInBlock(block, qty);

    const varSel = getVariantSelectFromBlock(block);
    const variantId = varSel ? normalizeVariantId(varSel.value) : null;

    pendingContext = {
      qty,
      variantId: variantId || null,
      until: performance.now() + 8000,
    };
  }

  document.addEventListener("click", registerPendingRebuyCartContext, true);
  document.addEventListener("pointerdown", registerPendingRebuyCartContext, true);

  function attachRebuyFetchInterceptor() {
    const upstream = window.fetch.bind(window);

    function rebuyCartFetchWrapper(input, init) {
      if (pendingContext && performance.now() > pendingContext.until) {
        pendingContext = null;
      }

      const url = getFetchUrl(input);
      const active =
        pendingContext &&
        performance.now() < pendingContext.until &&
        typeof url === "string" &&
        url.includes("/cart/add");

      if (!active) {
        return upstream.call(this, input, init);
      }

      const ctx = pendingContext;

      if (
        input instanceof Request &&
        (!init || init.body === undefined) &&
        input.method === "POST"
      ) {
        return input
          .clone()
          .text()
          .then((bodyText) => {
            const patched = tryPatchInit({ body: bodyText }, ctx);
            if (patched.body !== bodyText) {
              pendingContext = null;
              return upstream(url, {
                method: input.method,
                headers: input.headers,
                body: patched.body,
                credentials: input.credentials,
                mode: input.mode,
                cache: input.cache,
                redirect: input.redirect,
                referrer: input.referrer,
                integrity: input.integrity,
                signal: input.signal,
                keepalive: input.keepalive,
              });
            }
            pendingContext = null;
            return upstream.call(this, input, init);
          })
          .catch(() => upstream.call(this, input, init));
      }

      const nextInit = tryPatchInit(init || {}, ctx);
      pendingContext = null;
      return upstream.call(this, input, nextInit);
    }

    rebuyCartFetchWrapper.__rebuyMainProductSync = true;
    window.fetch = rebuyCartFetchWrapper;
  }

  attachRebuyFetchInterceptor();

  const origXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this.__rebuyXhrUrl = typeof url === "string" ? url : String(url || "");
    return origXhrOpen.apply(this, [method, url, ...args]);
  };
  const origXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    const url = this.__rebuyXhrUrl || "";
    const active =
      pendingContext &&
      performance.now() < pendingContext.until &&
      typeof url === "string" &&
      url.includes("/cart/add");
    if (!active) return origXhrSend.apply(this, arguments);
    const ctx = pendingContext;
    if (typeof body === "string" && body.trim().charAt(0) === "{") {
      const patched = tryPatchInit({ body }, ctx);
      if (patched.body !== body) {
        pendingContext = null;
        return origXhrSend.call(this, patched.body);
      }
    }
    if (body instanceof FormData) {
      const qBefore = body.get("quantity");
      const q0Before = body.get("items[0][quantity]");
      tryPatchInit({ body }, ctx);
      const qAfter = body.get("quantity");
      const q0After = body.get("items[0][quantity]");
      if (qBefore !== qAfter || q0Before !== q0After) {
        pendingContext = null;
        return origXhrSend.call(this, body);
      }
    }
    pendingContext = null;
    return origXhrSend.apply(this, arguments);
  };

  window.addEventListener(
    "load",
    function () {
      if (typeof window.fetch === "function" && !window.fetch.__rebuyMainProductSync) {
        attachRebuyFetchInterceptor();
      }
    },
    { once: true }
  );
})();
